/*
 * Copyright Deskshare, Inc.
 * All rights reserved.
 *
 * This software is proprietary and confidential.
 * Unauthorized copying, distribution, or use is strictly prohibited.
 */

import { createAuthClient } from "better-auth/react";
import { emailOTPClient } from "better-auth/client/plugins";

import configuration from "@/config/configuration";
export const authClient = createAuthClient({
  baseURL: configuration.better_auth_url,
  plugins: [emailOTPClient()],
});
